(function() {
    var isMobile = window.innerWidth < 768;
    this.$KRP0009 = $('.KRP0009'); // 개별 개발페이지 어디서 호출할지 알수없어 유지 2024-03-25

    function fncReady() {
        var $component;
        var $items;
        var $smoothScrollTarget; // 탭 메뉴 좌우 스크롤 영역
        var $subSticky; // 상세정보 내부 탭 // KRC0040
        var $setModelComponent // 제품상세 내용변경 탭 // KRP1201

        var currentId = null; // #overview | #pdp_spec ..
        var isScrollDown = true; // setIsScrollDown() 통해 변경
        var isOver = false; // fixed 되는 순간 true
        var isLockDirect = false; // 실제 화면 이동 방향은 변경되지만 상태는 변경하고 싶지 않을 때 true
        var headerH; // header 높이 px
        var headerResizeObserver = null; // header 크기 변경 감지 옵저버
        
        var lastScrollTop = 0;

        var $pdpWrap;
        var $header;

        var resizeObservers = {};
        var jumpPos = null;

        function init() {
            setting();
            bindEvents();

            initSmoothScroll();
            initHeaderResizeObserver();
            refresh();
        }

        function setting() {
            $component = $('.KRP0009');
            $items = $component.find('.tab-menu-belt li');

            $smoothScrollTarget = $component.find('.ui_smooth_scroll');
            $subSticky = $('.KRC0040');
            $setModelComponent = $('.KRP1201');
            $smartPackageArea = $('.package-product-area');

            $pdpWrap = $('.subRenewPdpWrap');
            $header = $pdpWrap.find('header.header');
            $subRenewNavWrap = $pdpWrap.find('.sub-renew-nav-wrap');
        }
        
        function bindEvents() {
            $component.data('inited', true); // BTOCSITE-55284 // krp0008 에서 초기화 구분위해 사용

            $(window).off('.KRP0009-2');
            $component.off('.KRP0009-2');

            $(window).on('load.KRP0009-2', scrollEvent); // BTOCSITE-54289 구독 탐색 강화 - 중복방지 off() 없어 추가합니다.
            $(window).on('scroll.KRP0009-2', scrollEvent); // BTOCSITE-54289 구독 탐색 강화 - 중복방지 off() 없어 추가합니다. 
            $(window).on('resize.KRP0009-2', resizeEvent); 
            $(window).on('breakpointchange.KRP0009-2', breakpointChange);

            $component.on('click.KRP0009-2', '.tab-menu-belt li a', function (e) {
                e.preventDefault();

                // console.log('!!!!! click');

                var id = $(this).attr('href');
                var $item = $(this).closest('li');
                
                if ($smoothScrollTarget.hasClass('expanded')) {
                    $smoothScrollTarget.removeClass('expanded');
                    $smoothScrollTarget.vcSmoothScroll('update');
                    $smoothScrollTarget.vcSmoothScroll('scrollToElement', $item[0]);
                }

                if (e) exactScrollMove(e.currentTarget, id); // BTOCSITE-55284 // 이동 목적지 이전 컴포넌트 lazyload 체크
            });

            $component.on('click.KRP0009-2', '.tab-menu-list li a', function (e) {
                e.preventDefault();

                var id = $(this).attr('href');
                
                if (e) exactScrollMove(e.currentTarget, id); // BTOCSITE-55284 // 이동 목적지 이전 컴포넌트 lazyload 체크
            });

            //////////////////// 이하 탭 클릭 포커싱 개선 전 이벤트들 .KRP0009 네임스페이스로 .off() 전부 추가, KRP1201 클릭하면 fncReady 재호출되므로 ///////////////////////////////////

            // LGECOMVIO-20 - PDP 개선건
            var smoothId = null
            if ($('.subRenewPdpWrap').length > 0) {
                $component.find('.accordion-button').off('click.KRP0009').on('click.KRP0009', function () {

                    //BTOCSITE-81509 웹접근성 탭 횡스크롤 병합 오류 수정(BTOCSITE-87685)
                    clearTimeout(smoothId);
                    $smoothScrollTarget.find('.tab-menu-belt').addClass('no-transition')
                    smoothId = setTimeout(function(){
                        $smoothScrollTarget.find('.tab-menu-belt').removeClass('no-transition')
                    },500);


                    toggleExpandMenu();
                });
            }

            $(window).off('changeCategory.KRP0009').on('changeCategory.KRP0009', function (e, data) {
                if (data) {
                    var $li = $component.find('.tab-menu-belt li a[data-link-name="' + data.linkName + '"]');
                    if ($li.length > 0) {
                        $li.text(data.title);
                    }
                }
            });

            //jsw
            //$(window).trigger("changeButton.KRP0009",{"title":btnTitle,"disabled":false});
            // BTOCSITE-1997 렌탈 PDP페이지 탭영역 버튼 노출 수정 - 210812
            $(window).off('changeButton.KRP0009').on('changeButton.KRP0009', function (e, data) {
                //var btn = $component.find("a.extra-menu");
                var btn = $component.find("#extraBtn");
                if (data && data.title != "" && data.title != undefined) {
                    btn.find('span').text(data.title);
                    if (data.disabled) {
                        btn.addClass('disabled');
                    } else {
                        btn.removeClass('disabled');
                    }
                    btn.show();
                } else {
                    btn.hide(); // BTOCSITE-1997 210810 추가
                }
            });
            // BTOCSITE-1997 렌탈 PDP페이지 탭영역 버튼 노출 수정 - 210812

            //BTOCSITE-48266 [상품] B2B OBS 구축
            if(lgkorUI.getHiddenInputData().b2cYN === "N"){
                b2bClickEventLoad();
            }

            $component.find("#extraBtn").off('click.KRP0009').on('click.KRP0009', function (e) {
                e.preventDefault();
                //BTOCSITE-48266 [상품] B2B OBS 구축
                if(lgkorUI.getHiddenInputData().b2cYN === "Y"){
                    if (!$(this).hasClass("disabled")) $(window).trigger("sendExtraAction.KRP0009");
                }else if(lgkorUI.getHiddenInputData().b2cYN === "N" && lgePdpSendData.modelStatusCode ==="ACTIVE"){
                    if(lgkorUI.stringToBool(loginFlag)){
                        let inputdata = lgkorUI.getHiddenInputData();
                        if(inputdata.memberPartnerGrp === "ENT"){ //사업자회원(승인 완료)
                            if (!$(this).hasClass("disabled")) $(window).trigger("sendExtraAction.KRP0009");

                        }else if (inputdata.memberPartnerGrp === 'B2C' && vcui.isEmpty(inputdata.bsnsMbrStat)) { //B2C회원
                            $('#businessMembershipMoreAlert3').vcModal();
                        } else if(inputdata.memberPartnerGrp === 'B2C' && inputdata.bsnsMbrStat === 'WAIT') { //B2C회원(사업자회원 승인대기)
                            $('#businessMembershipMoreAlert4').vcModal();
                        }
                    }else{
                        $('#businessMembershipMoreAlert2').vcModal();
                    }
                }
                //BTOCSITE-48266 [상품] B2B OBS 구축
            })
        }
        
        // header 높이 변경 옵저버, 띠배너등 닫을 때 감지 위해
        function initHeaderResizeObserver() {
            if ($header.length) {
                if (headerResizeObserver) {
                    headerResizeObserver.unobserve($header.get(0));
                    headerResizeObserver = null;
                }

                headerResizeObserver = new ResizeObserver(function (entries) {
                    entries.forEach(function (entrie) {
                        if (entrie.contentBoxSize[0].blockSize !== headerH) {
                            refresh();
                        }
                    })
                });
    
                headerResizeObserver.observe($header.get(0));
            }
        }

        function initSmoothScroll() {
            var smoothScroll = $smoothScrollTarget.vcSmoothScroll('instance', false);

            if (smoothScroll) smoothScroll.destroy();

            // BTOCSITE-61605 [모니터링][MO] USP영역 포커싱 되지 않음
            $smoothScrollTarget.vcSmoothScroll({ activeClass : 'active', getViewWidth: function () {
                var $ul = $smoothScrollTarget.find('> ul');

                var wrapWidth = $smoothScrollTarget.innerWidth();

                if (!!$ul.length) {
                    var ulStyle = window.getComputedStyle($ul.get(0)) || {};
                    var leftSpace = parseInt(ulStyle.paddingLeft) || 0;
                    var rightSpace = parseInt(ulStyle.paddingRight) || 0;

                    wrapWidth -= leftSpace + rightSpace;
                }

                return wrapWidth;
            }});
        }

        function refresh() {
            updateLayout();
            scrollEvent();
            setAccordionButton();
        }

        function breakpointChange(e, data) {
            // console.log('!!!!! breakpointChange', data);
            isMobile = data.isMobile;

            refresh();
        }

        function resizeEvent() {
            setAccordionButton();
            setSubStickyStatus();
        }

        // 레이아웃 업데이트 함수
        function updateLayout() { 
            headerH = isMobile ? $header.outerHeight() : 0;
        }

        /**
         * isScrollDown 정의 함수
         * @param {number} from 현 y 위치
         * @param {number} to 목적 y 위치
         * @returns {array}
         */
        function setIsScrollDown(from, to) {
            var pageDirection = (from !== to) ? vcui.math.getDirection({y: from}, {y: to}, 'vertical') : null;
            var isDown = (pageDirection) ? pageDirection === 'up' : null; // true | false | null
            
            // 변화없음을 원하거나 방향이 바뀌지 않으면 isScrollDown 변화 없도록.. 스티키 기존상태 유지위해
            if (!isLockDirect && isDown !== null) isScrollDown = isDown;
        }

        /**
         * 상제정보 영역 다음인지 유무
         * @returns {boolean}
         */
        function getOverviewNext() {
            return currentId !== null && currentId !== '#overview'
        }

        /**
         * 스티키 요소들 bottom값 배열로 반환
         * @param {string} id #포함한 id - 특정 위치로 이동했을 때의 bottom값 받기 위해 필요
         * @returns {array}
         */
        function getStickyBottom(id) {
            var menuH = $component.outerHeight() || 0;
            var setModelMenuH = $setModelComponent.outerHeight() || 0;
            // var subStickyMenuH = $subSticky.outerHeight() || 0;

            var bottomArr = [];

            // 헤더
            bottomArr.push(!isScrollDown ? headerH : 0); // !isScrollDown - 화면 위로 올릴 때 header 높이 필요
            
            // 스마트홈 // BTOCSITE-62058 스마트홈 경험 솔루션
            if (isMobile && !!$smartPackageArea.length) bottomArr.push(!isScrollDown ? bottomArr[bottomArr.length - 1] + $smartPackageArea.outerHeight() : 0);

            // 탭메뉴 (.KRP0009)
            bottomArr.push(bottomArr[bottomArr.length - 1] + menuH);

            // 제품상세 내용변경 탭 (.KRP1201) // sticky 때 doc 높이 빠지므로 수동 추가 ( 상세정보 내부 탭 .KRC00040 는 부모에 height 인라인 스타일 미리 적용되므로 수동추가 필요없음 )
            if (id === '#overview') bottomArr.push(bottomArr[bottomArr.length - 1] + setModelMenuH);

            return bottomArr;
        }

        /**
         * fixed로 인해 잃은 높이 반환
         * @returns {number}
         */
        function getLostWithFixedHeight() {
            var menuH = $component.filter('.fixed').outerHeight() || 0;
            var setModelMenuH = $setModelComponent.filter('.fixed').outerHeight() || 0;

            return menuH + setModelMenuH;
        }

        /**
         * 테블릿 사이즈 유무
         * @returns {boolean}
         */
        function getIsTablet() {
            return 767 < window.innerWidth && 1285 > window.innerWidth;
        }

        /**
         * 메뉴를 기반으로 컨텐츠 요소 반환
         * @param {jQueryElement} $elms 
         * @returns {jQueryElement}
         */
        function getContentFromMenu($elms) {
            // '#overview,#pdp_spec,#pdp_guide'
            var ids = $.map($elms.find('a[href^="#"]'), function (item) {
                return item.getAttribute('href')
            }).join(',');

            return $(ids);
        }

        /**
         * 위치값 반환 시 소수점으로 반환되어 일관성을 위해 해당 함수를 거쳐 계산
         * @param {number} value 
         * @returns {number} Math.ceil 로 통일 반환
         */
        function cutDecimal(value) {
            return Math.ceil(value);
        }

        function scrollEvent(e) {
            if (!$component.length) return;
            // 이동 전 화면 정리
            closeSetModelTab();

            var $parent = $component.parent();

            var scrollTop = cutDecimal($(window).scrollTop()); // 화면 스크롤 위치
            var menuTop = cutDecimal($parent.offset().top); // 임계값 대상 위치

            setIsScrollDown(lastScrollTop, scrollTop);

            var stack = isMobile && !!$smartPackageArea.length ? 1 : 0; // 스마트홈 메뉴가 탭메뉴 보다 위에 있기에 [1] 부터 시작 // BTOCSITE-62058 스마트홈 경험 솔루션
            var bottomArr = getStickyBottom();
            var threshold = (isScrollDown) ? menuTop : menuTop - headerH;  // 임계값 // 스크롤 방향에 따라 header 등장하므로 if 분기
            
            isOver = threshold <= scrollTop;

            //$setModelComponent.toggleClass('no-fixed', !isOver); // 불필요하여 삭제

            if (isOver) { // 탭메뉴 지나서
                // 컨텐츠 영역별 currentId 확정
                getContentFromMenu($items).each(function (idx, elm) {
                    var target = $(elm);
                    var id = '#' + $(elm).attr('id');

                    if (!!target.not(':hidden').length) {
                        var conTop = cutDecimal(target.offset().top); // 컨텐츠 top 값
                        
                        if (scrollTop + bottomArr[stack + 1] >= conTop) { // [1] - 탭메뉴 까지만 결정 영역에 포함
                            currentId = id;
                        }
                    }
                });

                // 탭메뉴 고정
                $component.addClass('fixed').css({ position: "fixed", top: bottomArr[stack], zIndex: 99 });

                // 탭메뉴 fixed 전후 높이 차이 감안 재계산 (가장 차이 많이나는 태블릿 사이즈..)
                bottomArr = getStickyBottom();

                // 다른 컴포넌트에서 위치 참조 위해 제공, e.g KRC0040
                $component.attr('data-bottom', bottomArr[stack + 1]);

                // 제품상세 내용변경 탭 고정
                $setModelComponent.addClass('fixed').css({ position: "fixed", top: bottomArr[stack + 1], zIndex: 99, visibility : getOverviewNext() ? 'hidden' : '' });

                // fixed로 인해 빠진 영역 설정, 단순 함수호출에는 반응 안함 ( 다른 ui 컴포넌트 scroll event를 불필요하게 반응시켜 상태가 변경되기 때문에 )
                if (e) $parent.css({height: getLostWithFixedHeight()});

                // header 그림자 숨김
                $header.addClass('shadow-none');
            } else {
                if (e) $parent.css({height: ''});

                $header.removeClass('shadow-none');

                $component.removeClass('fixed').removeAttr('style');
                $setModelComponent.removeClass('fixed').removeAttr('style');

                $component.removeAttr('data-bottom');

                currentId = null;
            }

            fixHeaderJS();

            changeActive();
            setSubStickyStatus();

            // console.log(currentId, '!!!!! scroll : ', scrollTop, ', threshold : ', threshold, ', bottonArr : ', bottomArr, ', over : ', isOver, ', down : ', isScrollDown)

            lastScrollTop = cutDecimal(window.scrollY);
        }

        // BTOCSITE-54289 구독 탐색 강화 
        function scrollMoved(id, options) {
            if ( $(id).length && $items.length ) {
                // 이동 전 화면 정리
                closeSetModelTab();
                //BTOCSITE-83472
                setHeaderMoveNew('no');

                var targetY = cutDecimal($(id).offset().top); // 스크롤 이동 목적 위치
                var scrollTop = cutDecimal($(window).scrollTop()); // 화면 스크롤 위치
                var extraH = 0; // 추가 높이 필요 시 지정할 변수
                
                var opts = Object.assign({ duration: 500 }, options); // aniate 옵션

                if (opts.duration !== 0) setIsScrollDown(scrollTop, targetY);
                var bottomArr = getStickyBottom(id);
                var lastBottom = bottomArr[bottomArr.length - 1];

                // + 아래로 더 내려감, - 위로 더 올라감
                var moveTop = targetY - lastBottom + extraH;
                
                // console.log('scrollTop', scrollTop, 'moveTop: ', moveTop, ', speed : ' + opts.duration, ', down : ', isScrollDown);

                // isScrollDown 방향과 jump 하려는 방향이 다를 때 (lazy 전 탭 클릭으로 스크롤 모션 후 컨텐츠 높이 재정의하는 과정에서 jump 목적지 변경되어 발생)
                if (opts.duration === 0 && (isScrollDown && scrollTop > moveTop)) {
                    // console.log("!!!!! reverse jump");
                    isLockDirect = true;  // scrollEvent() > isScrollDown() 에서의 방향지정 1회 막기
                }

                //BTOCSITE-83472
                window.pdpTabId = id;
                console.log('scrollMoved s')
                if( opts.startResizeObserver !== false){
                    console.log('startResizeObserver')
                    $(window).trigger('startResizeObserver');
                }
                console.log('scrollMoved e')   
                opts.complete = function(){
                    setTimeout(function(){
                        setHeaderMoveNew('no');
                        scrollEvent();
                        // [S] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 탭 이동 시 포커스 이동
                        $(id).attr('tabindex', 0).focus();
                        $(id).off('focusout.tab').on('focusout.tab', function(){
                            var $this = $(this);
                            $this.removeAttr('tabindex');
                            $(id).off('focusout.tab');
                        });
                        // [E] BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 탭 이동 시 포커스 이동
                    },20); 
                }
                //BTOCSITE-83472 이동거리 없으면 중단 
                if (scrollTop === moveTop || Math.abs(scrollTop - moveTop) == 1 ){
                    setHeaderMoveNew('no');
                    return;
                }else if(scrollTop > moveTop ){
                    setHeaderMoveNew('down')
                }else if(scrollTop < moveTop ){
                    setHeaderMoveNew('up')
                }

                /* $('html, body').stop().animate({
                    scrollTop: moveTop
                }, opts); */ // ios 탭 떨림 발생으로 scrollToElmTop 로 변경 // BTOCSITE-77460 PDP 탭앵커 이동 이슈 분석

                scrollToElmTop(moveTop, opts); // BTOCSITE-77460 PDP 탭앵커 이동 이슈 분석
            }
        }
        //BTOCSITE-83472
        $(window).on('resizeMoveTop',function(e,_id){
            scrollMoved(_id,{'startResizeObserver':false})
        }).on('resizeend',function(){
            if(window.innerWidth >= 768){
                 setHeaderMoveNew('no')
             }
         }); 
        if(window.pdpTabId){
            //console.log('KRP0008 > KRP0009')
            setTimeout(function(){
                console.log('KRP0008 > KRP0009')
                // KRP0008.js, KRP0009.js 순으로 실행되는데 둘사이에 딜레이가 크면 KRP0008 에서 예약(window.pdpTabId) 받아서 KRP0009 의 scrollMoved 실행한다
                scrollMoved(window.pdpTabId,{'startResizeObserver':true})
            },20);
        }
        function setHeaderMoveNew( direction ){
            if(window.innerWidth < 768){
                var $header = $('header.header');
                var $comp = $('.component.KRP0009');
                var hTop = '46';
                if($header.hasClass('helloBar')){
                    hTop = '88'
                }
                $header.removeClass('top0').removeClass('top-88').removeClass('top-46')
                $comp.removeClass('top0').removeClass('top88').removeClass('top46')
                if(direction == 'down'){
                    $header.addClass('top0')
                    $comp.addClass('top'+hTop)    
                }else if(direction == 'up'){
                    $header.addClass('top-'+hTop)
                    $comp.addClass('top0') 
                }
            }
        }

        /**
         * jQuery .animate() 을 window.scrollTo 으로 대체하기 위한 함수
         * 
         * .animate() 으로 scrollTop 조정하면 scroll 이벤트 핸들러에서 컨트롤하는 fixed element 떨림문제 발생
         * duration 은 scrollTo 에서 지원하지 않아 세세한 속도 조정 불가
         * 
         * @param {number} value 스크롤 이동 Y 위치
         * @param {object} opts 기존 jq animate() 옵션
         */
        function scrollToElmTop(value, opts) {
            var eventName = 'scroll.scroll-to-elm-top';

            $(window).off(eventName);

            window.scrollTo({
                top: value,
                behavior: opts.duration !== 0 ? "smooth" : 'instant'
            });
            //BTOCSITE-83472
            new Promise(function (resolve) {
                function handler() {
                    var ceilY = Math.ceil(window.scrollY);
                    if (ceilY == value || (ceilY - 100 < value && ceilY + 100 > value)) { // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0 // 콜백 실행 조건 재설정
                        $(window).off(eventName);
                        resolve();
                    }
                }

                $(window).on(eventName, handler);
            }).then(function () {
                if (opts.complete) opts.complete();
            });
        }

        // header.js 스크롤 이벤트 .hide 관련 수정없이 작업하다보니 생긴 함수 
        function fixHeaderJS() {
            // gnb-fixed - css fixed 와 관련없고 header.js 에서 탭을 넘어서서 스크롤에 따라 header 컨트롤 적용유무 판단하는 class

            if (!!$smartPackageArea.length) { // 스마트홈은 탭 이전영역에서 header 고정하지 않으므로 .gnb-fixed 미적용 // BTOCSITE-62058 스마트홈 경험 솔루션
                $pdpWrap.removeClass('gnb-fixed');
                return; 
            }

            if (isLockDirect) {
                $pdpWrap.addClass('gnb-fixed'); // header.js 의 스크롤 이벤트 속 .hide 조작 막음
                isLockDirect = false;
            } else {
                $pdpWrap.toggleClass('gnb-fixed', isMobile && !isOver); // true면 탭 이전영역을 의미하며 스크롤 방향에 header 조정 안함 (모바일용)
            }
        }

        // 탭메뉴 확장 토글
        function toggleExpandMenu() {
            //BTOCSITE-87685 PDP 탭 횡스크롤 버벅임현상
            if($smoothScrollTarget.hasClass('expanded')){
                //$smoothScrollTarget.vcSmoothScroll('toggleEnabled',true)
                $smoothScrollTarget.removeClass('expanded')
                $smoothScrollTarget.vcSmoothScroll('moveFirst');
                
            }else{
                //$smoothScrollTarget.vcSmoothScroll('toggleEnabled',false)
                $smoothScrollTarget.removeAttr('style');
                $smoothScrollTarget.addClass('expanded')
                $smoothScrollTarget.vcSmoothScroll('scrollToActive');
            }
            setTimeout(function(){
                scrollEvent(); // 높이 갱신
            });
        }

        // 제품상세 내용변경 탭 닫기
        function closeSetModelTab() {
            if ($setModelComponent.find('.expanded').length > 0) {
                $setModelComponent.find('.btn-expand').click();
            }
        }

        function changeActive() {
                var act;

                if (currentId === null) {
                    act = 0; // 스티키 전 첫번째 활성화
                } else {
                    act = $items.find('a[href="' + currentId + '"]').closest('li').index() || null;
                }

                // console.log('!!!!! act : ', act, 'currentId : ', currentId);

                if($items.eq(act).find('span.blind').length === 0 ){
                    $items.eq(act).prepend('<span class="blind">선택됨</span>').siblings().find('span.blind').remove();
                }

                //BTOCSITE-87685 PDP 탭 횡스크롤 버벅임현상
                if(!$items.eq(act).hasClass('active')){
                    $items.eq(act).addClass('active').siblings().removeClass('active');

                    $smoothScrollTarget.vcSmoothScroll('scrollToActive');
                }
                ////BTOCSITE-87685 PDP 탭 횡스크롤 버벅임현상
                //
                //
                //
        }

        function setSubStickyStatus() {
            if (isOver && getOverviewNext()) {
                //BTOCSITE-87685 PDP 탭 횡스크롤 버벅임현상
                // $subSticky.find('.inner').slideUp(150, function () {
                //     $subSticky.hide();
                // });
                $subSticky.find('.inner').hide();
                $subSticky.hide();

            } else {
                //BTOCSITE-87685 PDP 탭 횡스크롤 버벅임현상
                //$subSticky.show().find('.inner').slideDown(150);
                $subSticky.find('.inner').show();
                $subSticky.show()

            }

            $subSticky.trigger('refresh.KRC0040-2'); // KRC0040 갱신
        }

        function setAccordionButton() {
            if ($smoothScrollTarget.find('> .tab-menu-belt').outerWidth() > $smoothScrollTarget.outerWidth()) {
                $smoothScrollTarget.addClass('hasButton');
            } else {
                $smoothScrollTarget.removeClass('expanded');
                $smoothScrollTarget.removeClass('hasButton');
            }
        }

        // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
        function focusInCont(id) {
            var $cont = $(id);
            
            if (!!$cont.length) {
                $cont.attr('tabindex', 0).focus();
                $cont.off('focusout.KRP0009-2').one('focusout.KRP0009-2', function () {
                    $cont.removeAttr('tabindex');
                });
            }
        }

        // <-- BTOCSITE-55284 [상품] PDP 최초 탭 클릭 시 앵커 이슈
         
        // 대상의 img.lazyload 로딩 모두 완료 유무 반환
        function getAllLoaded($target) {
            var loading = $target.find('img.lazyload').not(':hidden').filter(function (idx, item) {
                // console.log('!!!!! naturalHeight: ', item.naturalHeight, item.getAttribute('src'))
                return item.naturalHeight === 0
            });

            return loading.length === 0;
        }

        // img.lazyload 완료하지 못한 컨테이너 반환
        function getNotLoadCont($target) {
            return $target.filter(function (idx, el) {
                return !getAllLoaded($(el));
            });
        }

        // 강제 overflow, height 
        function fixHeightCont($target) {
            $target.each(function (idx, el) {
                var $el = $(el);

                $el.addClass('js-fix-height').css({
                    overflow: 'hidden',
                    height: $el.outerHeight()
                });
            })
        }

        // 강제 overflow, height 해제
        function restoreHeightCont() {
            $pdpWrap.find('.js-fix-height').css({
                overflow: '',
                height: ''
            }).removeClass('js-fix-height');
        }

        /**
         * // 위치 강제 이동 함수
         * @param {string} id 이동할 element id (# 포함)
         */
        function jumpScroll(id) {
            // console.log('!!!!! jumpScroll', id);
            scrollMoved(id, { duration: 0 });

            jumpPos = cutDecimal($(window).scrollTop());
        }

        // debounce 스크롤 이벤트, exactScrollMove 후 움직임 감지 위함
        function addDebounceScroll() {
            var handler = _.debounce(function (e) {
                // console.log('debounce : ', e.type , jumpPos, cutDecimal($(window).scrollTop()));

                if (jumpPos !== cutDecimal($(window).scrollTop())) {
                    // console.log('!!!!! catch moved');

                    jumpPos = null;
                    removeDebounceScroll();
                    destroyResizeObservers();
                }
            }, 10);

            $(window).off('scroll.KRP0009-2-debounce').on('scroll.KRP0009-2-debounce', handler);
            
            if ($('html').is('.touch')) {
                $('body').off('touchmove.KRP0009-2-debounce').on('touchmove.KRP0009-2-debounce', handler); // BTOCSITE-66143 [UI] 리뷰 내재화 후속 작업 - 리뷰 탭 앵커 스크롤 위치 오류
            }
        }

        // debounce 스크롤 이벤트 제거
        function removeDebounceScroll() {
            $(window).off('scroll.KRP0009-2-debounce');
            $('body').off('touchmove.KRP0009-2-debounce'); // BTOCSITE-66143 [UI] 리뷰 내재화 후속 작업 - 리뷰 탭 앵커 스크롤 위치 오류
        }

        /**
         * 리사이징 옵저버 등록
         * @param {function} fn 변경 감지할 때 실행할 함수
         */
        function initResizeObservers(fn) {
            $.each(resizeObservers, function(key, val) {
                resizeObservers[key] = new ResizeObserver(function (entries) {
                    entries.forEach(function (entrie) {
                        // console.log('!!!!! resizing -', key, ', size:', entrie.contentBoxSize[0].blockSize, ', all loaded:', getAllLoaded($(entrie.target)));
                        if (getAllLoaded($(entrie.target))) destroyResizeObservers(key);
                        if (fn) fn();
                    })
                });

                resizeObservers[key].observe($('#' + key).get(0));
            });
        }

        /**
         * 리사이징 옵저버 삭제
         * @param {string} value 특정 id, 없으면 모든 대상
         */
        function destroyResizeObservers(value) {
            if (value) {
                if (resizeObservers[value]) {
                    resizeObservers[value].disconnect();
                    resizeObservers[value] = null;
                    delete resizeObservers[value];

                    // console.log('!!!!! remove resizeObservers', value);
                }
            } else {
                $.each(resizeObservers, function(key, val) {
                    if (resizeObservers[key]) { //  exactScrollMove > scrollMoved 의 목적지 $(id) 가 없으면 initResizeObservers() 실행안되어 다음 호출에 해당값이 null 일수 있음. 그땐 delete 만 
                        resizeObservers[key].disconnect();
                        resizeObservers[key] = null;
                    }
                    delete resizeObservers[key];
                });

                // console.log('!!!!! remove resizeObservers all ~');
            }
        }

        /**
         * 이동 목적지 이전 컴포넌트 lazyload 체크 함수 // 정확한 scrollMoved() 를 위해 대신 실행
         * @param {element} el  탭 element
         * @param {string} id   이동할 element id (# 포함)
         * @returns 
         */
        function exactScrollMove(el, id) {
            if (!el && id) {
                scrollMoved(id);
                return;
            }

            // 상태 초기화
            removeDebounceScroll();
            destroyResizeObservers();

            // 목적지 이전요소들
            var $previous = getContentFromMenu($(el).closest('li').prevAll());
            var $lazyContainers = getNotLoadCont($previous); // 이전요소들 중 img.lazyload 완료 못한 컨테이너만

            // resizeObservers 대상 등록
            $lazyContainers.each(function (idx, el) {
                var id = $(el).attr('id');
                if (id) Object.defineProperty(resizeObservers, id, { value : null, writable: true, configurable: true, enumerable: true});
            });

            // 컨텐츠 높이 한계 지정
            fixHeightCont($lazyContainers);

            // 스크롤 이동 시작
            scrollMoved(id, {
                complete: function () {
                    //if ($(this).is('body')) { // animate() html, body 둘다 걸려있어서 한번만 콜백 위해
                        // console.log('!!!!! complete moved');
                        // 스크롤 이동 완료
                        restoreHeightCont(); // 한계 복구 후
                        jumpScroll(id); // 강제 이동
                        
                        addDebounceScroll(); // 이동 감지 활성화
                        initResizeObservers(function () { jumpScroll(id) }); // 사이즈 변경 감지 활성화

                        focusInCont(id); // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품, 가전구독, UP가전2.0
                    //} // scrollToElmTop 으로 변경하여 if문 삭제 // BTOCSITE-77460
                }
            });
        }

        // BTOCSITE-55284 [상품] PDP 최초 탭 클릭 시 앵커 이슈 -->

        init();
    }

    function fncLoad() {
        var $component = $('.KRP0009');
        var $items = $component.find('.tab-menu-belt li');
        var visited = Array.from({length: $items.length}, function (v, i) {
            return false;
        });

        $(window).off('scroll.KRP0009-fncLoad').on('scroll.KRP0009-fncLoad', function (e) {
            $items.each(function (idx, item) {
                if (!visited[idx]) {
                    var tab = $(item).children('a');
                    if (checkVisible(tab.attr('href'))) {
                        visited[idx] = true;
                        var label = tab.text();
                        if (label.startsWith('리뷰')) { 
                            label = '리뷰';
                        }
                        pushDataLayer(label);
                    }
                }
            })
        });

        function checkVisible(elm, eval) {
            if (!$(elm).length) {
                return false;
            }
            eval = eval || "object visible";
            var viewportHeight = $(window).height(),
                scrolltop = $(window).scrollTop(),
                y = $(elm).offset().top,
                elementHeight = $(elm).height();
            // console.log('elm: ', elm);
            // console.log('y: ', y);
            if (eval == "object visible") return ((y < (viewportHeight + scrolltop)) && (y > (scrolltop - elementHeight)));
            if (eval == "above") return ((y < (viewportHeight + scrolltop)));
        }

        function pushDataLayer(label) {
            if (typeof dataLayer !== 'undefined' && dataLayer) {
                //console.log('pushDataLayer: ', label);
                dataLayer.push({
                    'event': 'customEvent',
                    'ga4event': 'pdp_layout',
                    'customEventCategory': '완독률',
                    'customEventAction': '완독률 - 제품상세',
                    'customEventLabel': label
                });
            }
        }
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0009-2.0.0', isFirstLoad: false, fn: function () {
                if (!document.querySelector('.KRP0009')) return false;

                fncReady();
                fncLoad();
            }
        });
    }

    //BTOCSITE-48266 [상품] B2B OBS 구축
    function b2bClickEventLoad (e) {
        $('#businessMembershipLogin').unbind('click').bind('click',function(e){
            e.preventDefault();
            var loginUrl = "/sso/member/login?state=";
            var moveUrl = location.pathname + location.search;
            location.href = vcui.uri.updateQueryParam(
                loginUrl,
                "state",
                encodeURIComponent(moveUrl)
            );
        });

        $('#goCertification').unbind('click').bind('click',function(e){
            e.preventDefault();
            var moveUrl = location.pathname + location.search;
            var loginUrl = "/business/registration";
            location.href = vcui.uri.updateQueryParam(
                loginUrl,
                "state",
                encodeURIComponent(moveUrl)
            );
        });

    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    vcui.require(['libs/lodash-1.8.3.min'], function () {
        $(window).ready(function () {
            SAVE_COMPONENT_PDP_DOM_MNG();

            if (!document.querySelector('.KRP0009')) return false;

            fncReady();
        });
    })

    /* GA 완독률 */
    $(window).load(function () {
        fncLoad();
    });
})();